import React from "react";

type Props = { className?: string; label: string };

export const IconFacebook: React.FC<Props> = ({ className, label }) => (
  <svg className={className} width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <title>{label}</title>
    <path
      fill="currentColor"
      d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v7h3v-7h3l1-3h-4V10c0-.6.4-1 1-1z"
    />
  </svg>
);

export const IconInstagram: React.FC<Props> = ({ className, label }) => (
  <svg className={className} width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <title>{label}</title>
    <path
      fill="currentColor"
      d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm10 2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-5 3.2A3.8 3.8 0 1 1 8.2 12 3.8 3.8 0 0 1 12 8.2zm0 2A1.8 1.8 0 1 0 13.8 12 1.8 1.8 0 0 0 12 10.2zM17.2 6.6a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
    />
  </svg>
);

export const IconWhatsapp: React.FC<Props> = ({ className, label }) => (
  <svg className={className} width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <title>{label}</title>
    <path
      fill="currentColor"
      d="M12.04 2C6.5 2 2 6.4 2 11.85c0 1.85.5 3.6 1.4 5.15L2 22l5.15-1.35A10.1 10.1 0 0 0 12.04 22C17.6 22 22 17.55 22 12.05 22 6.5 17.6 2 12.04 2zm0 18.15c-1.7 0-3.3-.45-4.7-1.3l-.35-.2-3.05.8.8-2.95-.2-.35a8.1 8.1 0 0 1-1.3-4.6c0-4.5 3.7-8.15 8.2-8.15s8.2 3.65 8.2 8.15-3.7 8.6-8.2 8.6zm4.5-6.1c-.25-.1-1.45-.7-1.65-.8s-.4-.1-.55.15-.65.8-.8.95-.3.2-.55.05a6.7 6.7 0 0 1-2-1.25 7.4 7.4 0 0 1-1.35-1.7c-.15-.25 0-.4.1-.5s.25-.3.35-.45.15-.25.25-.4.05-.3 0-.45-.55-1.3-.75-1.8c-.2-.45-.4-.4-.55-.4h-.45c-.15 0-.4.05-.6.3s-.8.8-.8 1.9.8 2.2.95 2.35c.1.15 1.6 2.45 3.9 3.45 1.45.6 1.8.5 2.15.45.35-.05 1.1-.45 1.25-.9s.15-.8.1-.9-.2-.15-.45-.25z"
    />
  </svg>
);

export const IconMapPin: React.FC<Props> = ({ className, label }) => (
  <svg className={className} width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <title>{label}</title>
    <path
      fill="currentColor"
      d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z"
    />
  </svg>
);
